import { memo, useMemo } from 'react';

import { Box, Text } from '@bonanza-social/moonlight';
import { Trans } from '@bonanza-social/i18n';
import { formatDate } from '@bonanza-social/toolkit/utils';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectStatus } from '../../state';

function StatusResetDisclaimer() {
  const status = useSelector(selectStatus);

  const transComponents = useMemo(
    () => ({
      highlight: <Text variant="caption" color="darkSurfacePrimary" />,
    }),
    [],
  );

  if (!status || !status.expiryDate) {
    return null;
  }

  const date = formatDate(status.expiryDate, 'MMM DD, YYYY @ ha');

  return (
    <Box width="100%" gap="space-200">
      <Box
        variant="gradient"
        gradient={`status${status.playerStatus}Background`}
        height="space-025"
        width="100%"
        opacity={0.5}
      />
      <Text variant="caption" color="darkSurfaceMuted" textAlign="center">
        <Trans
          ns="status"
          i18nKey="statusResetDisclaimer"
          components={transComponents}
          values={{ date }}
        />
      </Text>
    </Box>
  );
}

export default memo(StatusResetDisclaimer);
